import { registerAuthRouteBackNavigation } from '~/entities/auth/model/registerAuthRouteBackNavigation'

export default defineNuxtPlugin(() => {
  registerAuthRouteBackNavigation()
})
